module.exports = __webpack_public_path__ + "img/6.dacf50e8.png";